export default __webpack_public_path__ + "static/media/azapay-logo.e16519db.png";